import type { MediaPreset } from "./types";

export const presets = {
	avatar: { maxWidth: 400, maxSizeMB: 0.15, fileType: "image/webp", initialQuality: 0.82 },
	feedMain: { maxWidth: 2048, maxSizeMB: 3, fileType: "image/webp", initialQuality: 0.9 },
	document: { maxWidth: 2048, maxSizeMB: 2, fileType: "image/jpeg", initialQuality: 0.85 },
	feedThumb: { maxWidth: 720, maxSizeMB: 0.35, fileType: "image/webp", initialQuality: 0.8 },
	scMain: { maxWidth: 2048, maxSizeMB: 3, fileType: "image/webp", initialQuality: 0.9 },
	scThumb: { maxWidth: 720, maxSizeMB: 0.35, fileType: "image/webp", initialQuality: 0.8 },
	messagingImage: { maxWidth: 2400, maxSizeMB: 3, fileType: "image/jpeg", initialQuality: 0.82 },
} as const satisfies Record<string, MediaPreset>;

export type PresetName = keyof typeof presets;
